import React from 'react';
import relanceEvent from './relance-event.png';

export const IconEmail: React.FC<{ className?: string }> = ({ className }) => (
    <img src={relanceEvent} alt="" aria-hidden="true" width={16} height={16} className={className} />
);
